export default __webpack_public_path__ + "static/media/lightbulb.d3f36adb.svg";